import { Button, Form, Switch } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React, { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
// import { useLocation } from 'react-router-dom';
import dayjs, { Dayjs } from 'lib/dayjs';
import { FilterIdType } from 'views/Refund/utils/constants';
import { usePlatform } from 'views/Refund/hooks/usePlatformList';
import { useMemoizedFn } from 'ahooks';
import { ClearOutlined } from '@ant-design/icons';
import { SnFormField } from './SnFormField';
import { StoreFormField } from './StoreFormField';
import { StyleFilter } from './style';
import { ApplyDateFormField } from './ApplyDateFormField';

export type FilterChangeEvent = {
  snType: FilterIdType;
  sn: string;
  dateRange?: [Dayjs, Dayjs];
};

export const initValues = {
  snType: FilterIdType.orderId,
  sn: null,
  sellerType: '',
  storeType: '',
  dateRange: [dayjs(dayjs().subtract(6, 'days').format('YYYY-MM-DD')), dayjs()],
  region: undefined,
  follower: undefined,
  storeList: undefined,
  leChatTraceStatus: [],
  reverseLeChatTraceStatus: [],
};

interface Props {
  onChange: (e: FilterChangeEvent) => void;
  filterType: 'return' | 'cancel';
  showDueTimeEnd?: boolean;
}

const RefundFilter = React.memo((props: Props) => {
  const { onChange, filterType, showDueTimeEnd } = props;
  const { t } = useTranslate();
  const platform = usePlatform()!;

  const [form] = Form.useForm();

  const handleSearchSubmit = useMemoizedFn(() => {
    form.submit();
  });

  const handleClearSubmit = useMemoizedFn(() => {
    form.resetFields();
    form.submit();
  });

  const handleFormFinish = useMemoizedFn((e: any) => {
    const { sn } = e;
    onChange({
      ...e,
      sn: !sn ? undefined : sn,
    });
  });

  const initialValues = useMemo(() => {
    return {
      ...initValues,
      dateRange: [
        dayjs(
          dayjs()
            .subtract(filterType === 'cancel' ? 6 : 30, 'days')
            .format('YYYY-MM-DD'),
        ),
        dayjs(),
      ],
    };
  }, [filterType]);

  return (
    <div className="bg-fill-0 flex flex-col p-4 gap-4">
      <StyleFilter form={form} initialValues={initialValues} onFinish={handleFormFinish}>
        <div className="filter-list">
          <SnFormField platform={platform} filterType={filterType} />
          <StoreFormField platform={platform} filterType={filterType} />
          <ApplyDateFormField form={form} filterType={filterType} />
          {platform === 'MERCADO' && (
            <FormItem label={t('仅看影响声誉')} name="reputation" valuePropName="checked">
              <Switch />
            </FormItem>
          )}
          <FormItem
            hidden={!showDueTimeEnd}
            label={t('需24小时内处理')}
            name="dueTimeEnd"
            valuePropName="checked"
          >
            <Switch />
          </FormItem>
        </div>
        <div className="flex gap-2">
          <FormItem className="!mb-0">
            <Button
              type="primary"
              htmlType="submit"
              className="!min-w-32"
              onClick={handleSearchSubmit}
            >
              {t('搜索订单')}
            </Button>
          </FormItem>
          <Button type="link" onClick={handleClearSubmit}>
            <ClearOutlined />
            {t('todo.清除条件')}
          </Button>
        </div>
      </StyleFilter>
    </div>
  );
});

export default RefundFilter;
